// Referral page query param with the invited user ID whose friend card should open, e.g. from a referral toast.
export const REFERRAL_OPEN_FRIEND_PARAM = 'openFriend';
